enum InterestRateType {
    Fixed = "FIXED",
    Variable = "VARIABLE",
}
export default InterestRateType